import React from 'react'
import {Button, ButtonProps} from "semantic-ui-react";

const SecondaryButton = (props: ButtonProps) => {
    const btnProps = {...props, basic: true};
    return <Button  {...btnProps} className="noborder" />
};

export default SecondaryButton;